// extracted by mini-css-extract-plugin
export default {"body":"Body_body__oeqV2","content":"Body_content__YsRtm"};